import "core-js/modules/web.dom-collections.iterator.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useEffect, useState } from 'react';
import Cancel from '@pixel/assets/icons/Cancel';
import Close from '@pixel/assets/icons/Close';
import FileUploadService from './FileUploadService';
import Typography from "../Typography";
import CircularProgress from "../CircularProgress";
import Box from "../Box";
import { styled } from '../styles';
const Progress = styled("div")(_ref => {
  let {
    theme
  } = _ref;
  return {
    height: "40px",
    position: "relative",
    borderRadius: theme.spacing(0.4),
    background: theme.palette.background.paper,
    border: "0.4px solid",
    marginBottom: theme.spacing(1)
  };
});
const Bar = styled("div", {
  shouldForwardProp: prop => prop !== 'percent' && prop !== 'errors'
})(_ref2 => {
  let {
    theme,
    percent,
    errors
  } = _ref2;
  return {
    height: "39px",
    background: errors.length ? theme.palette.error.main : theme.palette.grey[300],
    // "rgb(156 156 156)",
    borderRadius: theme.spacing(0.4),
    width: "".concat(percent, "%"),
    transition: "width 0.5s",
    alignItems: 'center'
  };
});
const FileDetails = styled("div")(_ref3 => {
  let {
    theme
  } = _ref3;
  return {
    height: "40px",
    position: "absolute",
    top: theme.spacing(0),
    bottom: theme.spacing(0),
    left: theme.spacing(1),
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "left"
  };
});
const IconDiv = styled("div")(_ref4 => {
  let {
    theme
  } = _ref4;
  return {
    position: "absolute",
    bottom: theme.spacing(0),
    right: theme.spacing(2),
    alignItems: "center",
    justifyContent: "right",
    cursor: "pointer",
    display: "block"
  };
});
function CircularProgressWithLabel(props) {
  const {
    value
  } = props;
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      position: 'relative',
      display: 'inline-flex',
      marginRight: "10px"
    }
  }, /*#__PURE__*/React.createElement(CircularProgress, _extends({}, props, {
    size: 25
  })), /*#__PURE__*/React.createElement(Box, {
    sx: {
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: "text.secondary"
  }, "".concat(Math.round(value), "%"))));
}
const SingleFileUpload = _ref5 => {
  let {
    file,
    onDelete,
    onUpload,
    errors,
    uploadUrl,
    onError,
    onUploadCallback
  } = _ref5;
  const [progress, setProgress] = useState(0);
  // const [xhrError, setXhrError] = useState("");
  const [xhrReq, setXhrReq] = useState(null);
  const handleCancel = () => {
    xhrReq.abort();
    onDelete(file);
  };
  useEffect(() => {
    async function upload() {
      const xhr = FileUploadService({
        uploadUrl,
        file,
        onProgress: setProgress,
        onError,
        onDelete
      });
      setXhrReq(xhr);
      xhr.onload = () => {
        if (xhr.status === 200) {
          const resp = JSON.parse(xhr.responseText);
          onUpload(file, resp.secure_url, resp);
          if (typeof onUploadCallback === 'function') {
            onUploadCallback(resp);
          }
        } else {
          if (typeof onError === 'function') {
            onError('server', file, xhr.statusText, xhr.status);
          }
          onDelete(file);
        }
      };
    }
    if (errors.length > 0) {
      setProgress(100);
      if (typeof onError === 'function') {
        const fileWithErrors = {
          error: errors,
          file
        };
        onError('file', fileWithErrors, "".concat(errors.length > 1 ? "".concat(errors[0].message, " + ").concat(errors.length - 1, " other errors") : errors[0].message, " "), "file-with-errors");
      }
      onDelete(file);
      return;
    }
    upload();
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Progress, {
    id: "progress"
  }, /*#__PURE__*/React.createElement(Bar, {
    id: "up-bar",
    percent: progress,
    errors: errors
  }), /*#__PURE__*/React.createElement(FileDetails, {
    id: "up-percent"
  }, /*#__PURE__*/React.createElement(Typography, null, file.name)), /*#__PURE__*/React.createElement(IconDiv, null, progress < 100 && /*#__PURE__*/React.createElement(CircularProgressWithLabel, {
    value: progress
  }), progress < 100 ? /*#__PURE__*/React.createElement(Cancel, {
    onClick: handleCancel
  }) : /*#__PURE__*/React.createElement(Close, {
    onClick: () => onDelete(file)
  }))), errors.length > 0 && errors.map(error => /*#__PURE__*/React.createElement("div", {
    key: error.code
  }, /*#__PURE__*/React.createElement(Typography, {
    color: "error"
  }, error.message))));
};
export default SingleFileUpload;